<template lang="pug">
  .content.background
    .card.lg-body.body-login
      .row
        .col-md-6(style="background-color: #E6F2FF;height: 530px;margin-top: -15px;")
          div(style="margin-top: 140px;margin-left: 90px;")
            img(:src='logo')
        .col-md-6(style="margin-top: 65px;padding-left: 40px;" v-if="this.forgetpass == 0")
          .col-md-12.body-login-mobile
            div.lg-img.text-center
              div(style="text-align: left;font: normal normal bold 42px/51px Roboto;letter-spacing: 0px;color: #212529;") Đăng nhập
              div(style="color: var(--unnamed-color-6c757d);text-align: left;font: normal normal normal 16px/19px Roboto;letter-spacing: 0px;color: #6C757D;opacity: 1;") Vui lòng điền tên đăng nhập và mật khẩu để bắt đầu sử dụng
            div.lg-img.text-center
              .card-content.lg-custom-card-content
                div.col-md-12(style="margin-left: -15px;")
                  .alert.alert-danger(v-if="errors")
                    .txt-error {{errors}}
                div.form-group.row(style="margin:0;")
                  div(style="margin-top: 20px; color: var(--unnamed-color-212529);text-align: left;font: normal normal bold 16px/19px Roboto;letter-spacing: 0px;color: #212529;opacity: 1;") Tên đăng nhập
                  div.col-md-12(style="margin-left: -14px;")
                    .form-group.custom-form-group(style='position:relative;margin-top:10px;')
                      input#username.form-control(class="form-custom" type="text" name="code" placeholder="Tên đăng nhập" required style='padding-right: 40px !important;' autofocus v-model="code" autocomplete="off")
                      i.material-icons.lg-icon-account account_circle
                div.form-group.row(style="margin:0;")
                  div(style="margin-top: 10px; color: var(--unnamed-color-212529);text-align: left;font: normal normal bold 16px/19px Roboto;letter-spacing: 0px;color: #212529;opacity: 1;") Mật khẩu
                  div.col-md-12(style="margin-left: -14px;")
                    .form-group.custom-form-group(style='position:relative;margin-top:10px;')
                      input#password.form-control(class="form-custom" v-model="password" :type='passwordType' placeholder="Mật khẩu" required style='padding-right: 40px !important;' v-on:keyup="validateEmailAddress")
                      i.material-icons.lg-icon-password(@click="switchVisibility" v-if="passwordType === 'text'" style="position: absolute;margin-top: -30px;margin-left: 182px;") visibility
                      i.material-icons.lg-icon-password(@click="switchVisibility" v-else style="position: absolute;margin-top: -30px;margin-left: 182px;") visibility_off
                div.form-group.row.mb-0.text-left(style='margin-top: 2px;')
                  div.col-md-12
                    button.btn.btn-custom(@click='submitFormLogin' style="width: 436px;") Đăng nhập
                div.form-group.row.mb-0.text-center(style='margin-top: 10px;') 
                  div.col-md-12(@click='forgetpassword' style="margin-left: -11px;cursor: pointer;color: var(--unnamed-color-0a84ff);font: normal normal normal 16px/21px Roboto;letter-spacing: 0px;color: #0A84FF;opacity: 1;") Quên mật khẩu
        .col-md-6(style="margin-top: 225px;padding-left: 40px;" v-else)     
          .col-md-12.body-login-mobile
            div.lg-img.text-center
              div(style="text-align: left;font: normal normal bold 42px/51px Roboto;letter-spacing: 0px;color: #212529;") Quên mật khẩu
              div(style="color: var(--unnamed-color-6c757d);text-align: left;font: normal normal normal 16px/19px Roboto;letter-spacing: 0px;color: #6C757D;opacity: 1;") Vui lòng liên hệ với Kỹ Thuật Viên để nhận lại mật khẩu
            div.form-group.row.mb-0.text-center(style='margin-top: 10px;') 
              div.col-md-12(@click='backtologin' style="margin-left: -11px;cursor: pointer;color: var(--unnamed-color-0a84ff);font: normal normal normal 16px/21px Roboto;letter-spacing: 0px;color: #0A84FF;opacity: 1;") Đăng nhập lại

</template>

<script>
import firebase from "firebase";
import gql from "graphql-tag";
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      errors: null,
      passwordType: "password",
      countSubmit: 0,
      group_permission: {},
      code: "",
      forgetpass: 0
    };
  },
  apollo: {},
  computed: {
    logo() {
      return (this.forgetpass === 0) ? "../../../assets/layout/images/logo1.png" : "../../../assets/layout/images/lock.svg";
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    forgetpassword() {
      this.forgetpass = 1
    },
    backtologin() {
      this.forgetpass = 0
    },
    switchVisibility() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    validateEmailAddress(e) {
      if (e.keyCode === 13) this.submitFormLogin();
      else if (e.keyCode === 27) this.password = "";
    },
    async validateData() {
      var hasError = false;
      var that = this;
      let query = `query MyQuery($code: String) {
          users(where: {code: {_eq: $code}, deleted: {_eq: false}}) {
            email
            active
            users_account {
              role
            }
          }
        }
      `;
      await this.$apollo
        .query({
          query: gql(query),
          variables: {
            code: this.code,
          },
        })
        .then(async (res) => {
          console.log("check code", res);
          var res_user = res;
          if (res.data.users.length > 0) {
            if (res.data.users[0].active == false) {
              hasError = true;
              that.errors = "Tài khoản đã bị vô hiệu hoá";
            } else {
              that.email = res.data.users[0].email;
              let query = `query MyQuery($email: String) {
              users(where: {users_account: {role: {_neq: "admin"}}, email: {_eq: $email}, deleted: {_eq: false}}) {
                group_permissions {
                  id
                  group_permission_details {
                    view
                    list
                    export
                    edit
                    delete
                    add
                    delete_group
                    permission {
                      key
                    }
                  }
                }
              }
            }
            `;
              await this.$apollo
                .query({
                  query: gql(query),
                  variables: {
                    email: this.email,
                  },
                })
                .then(async (res) => {
                  // console.log('------------------------------', res.data)
                  if (res.data.users.length > 0) {
                    var role_key = (res_user.data.users[0].users_account.length>0) ? res_user.data.users[0].users_account[0]["role"]:null;
                      if (
                          res.data.users[0].group_permissions
                              .group_permission_details.length > 0
                      ) {
                        let group_permission_all =
                            res.data.users[0].group_permissions
                                .group_permission_details;
                        for (let i = 0; i < group_permission_all.length; i++) {
                          const e = group_permission_all[i];
                          let abc = {};
                          abc = {
                            add: e.add,
                            edit: e.edit,
                            export: e.export,
                            delete: e.delete,
                            list: e.list,
                            view: e.view,
                            delete_group: e.delete_group,
                          };
                          that.group_permission[e.permission.key] = abc;
                        }
                        console.log(
                            "this.group_permission",
                            that.group_permission
                        );
                        this.$store.commit(
                            "setGroupPermission",
                            that.group_permission
                        );
                        console.log("user tdv permission", this.$store.getters);
                        if (role_key == 'court'){
                          that.$store.commit("setRole", "court");
                        }else {
                          that.$store.commit("setRole", "dpv");
                        }
                        that.$store.commit(
                            "setGroupPermissionId",
                            res.data.users[0].group_permissions.id
                        );
                      }
                  } else {
                    that.$store.commit("setRole", "admin");
                  }
                })
                .catch((error) => {
                  console.log("ERROR: ", error);
                });
            }
          } else {
            hasError = true;
            that.errors = "Tài khoản không tìm thấy";
          }
        });
      return hasError;
    },
    async submitFormLogin() {
      var that = this;
      if (await this.validateData()) {
        return;
      }
      if (this.code === "" || this.password === "") {
        this.errors = "Tên đăng nhập không được bỏ trống";
      } else {
        console.log("email", this.email);
        const user = {
          email: this.email,
          password: this.password,
        };
        this.$store
          .dispatch("signInAction", user)
          .then(async () => {
            var user = await firebase.auth().currentUser;
            console.log("user", user);
            console.log("token", this.$store.getters.token);
            if (!user.emailVerified) {
              user.sendEmailVerification().then(
                function() {
                  that.errors = "Vui lòng vào email để xác nhận tài khoản";
                },
                function() {
                  that.errors = "Tài khoản chưa được xác nhận";
                }
              );
            } else {
              console.log(1)
              that.$router.push({ name: "admin", params: { reload: true } });
            }
          })
          .catch((error) => {
            // console.log('error', error)
            if (
              error.code === "auth/user-not-found" ||
              error.code === "auth/wrong-password"
            ) {
              that.errors = "Tài khoản không tìm thấy.";
            } else if (error.code === "auth/invalid-email") {
              that.errors = "Email trống hoặc không đúng định dạng.";
            } else {
              that.errors = error;
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
:root {
  --color-lg-fb: #3b5998;
  --color-lg-gg: #da4837;
  --color-lg-yellow: #ffd311;
}
.body-login {
  width: 1100px;
  height: 530px;
  // margin: 0 auto;
  margin-top: 100px;
  margin-left: 237px;
  .lg-img {
    background: transparent;
    margin-bottom: 10px;
  }
  .lg-body {
    margin-left: 0%;
    margin-top: 0;
    width: 1100px;
    height: auto;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 5px;
    opacity: 1;
    padding-top: 152px;
    padding-left: 307px;
    .lg-custom-card-content {
      padding-top: 0;
      padding-left: 10px;
      padding-right: 10px;
      .line-strike {
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #b4b4b4;
        line-height: 0.1em;
        margin: 30px 0px;
        span {
          background: #fff;
          padding: 0 10px;
          color: #b4b4b4;
          font-family: "adobe-clean", sans-serif;
        }
      }
      .custom-btn-fb {
        background-color: var(--color-lg-fb);
        color: white;
        font-size: 15px;
        font-family: "adobe-clean", sans-serif;
        text-align: center;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        display: block;
        width: 190x;
        height: 50px;
        margin-left: 50px;
        padding-top: 15px;
        cursor: pointer;
      }
      .custom-btn-gg {
        background-color: var(--color-lg-gg);
        color: white;
        font-size: 15px;
        // font-weight: bold;
        font-family: "adobe-clean", sans-serif;
        text-align: center;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        display: block;
        width: 190x;
        height: 50px;
        margin-left: 50px;
        padding-top: 15px;
        cursor: pointer;
      }
      .lg-icon-password {
        margin-top: -30px;
        display: block;
        position: absolute;
        right: 10px;
        padding: auto 5px;
        &:hover {
          cursor: pointer;
        }
      }
      .lg-btn-save {
        background: var(--color-lg-yellow);
        color: black;
        text-transform: none;
        font-size: 14px;
        font-family: "adobe-clean", sans-serif;
        border: 1px solid #ffd311;
        border-radius: 5px;
        // box-shadow: 0px 0px 0px;
        margin-top: 0px !important;
        width: 100%;
      }
      .lg-reg-pull-right {
        float: right;
      }
      .lg-forgot-password {
        font-family: "adobe-clean", sans-serif;
        &:hover {
          cursor: pointer;
        }
      }
      .lg-reg-now {
        font-family: "adobe-clean", sans-serif;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
.form-custom {
  padding-right: 42.5px;
  border-radius: 0 !important;
  box-shadow: none;
  border-color: #d2d6de;
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  font-family: inherit;
}
.lg-icon-account {
  margin-top: -30px;
  display: block;
  position: absolute;
  right: 10px;
}
.btn-custom {
  height: 35px !important;
  background: linear-gradient(to right, #0388e5 0%, #07bdf4 100%) !important;
  border: 1px solid #116fbf !important;
  margin-top: 8px !important;
  cursor: pointer !important;
  color: white;
  text-transform: none;
  font-size: 14px;
  font-family: "adobe-clean", sans-serif;
  border-radius: 5px;
  width: 100%;
}
</style>
